"use client";

import type {
  SignUpElement,
  SignUpType,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import {
  getSignUpLink,
  trackSignUpClick,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUpUtils";
import { trackSignupSignUpToShopButtonClick } from "@faire/web-api--source/events/signup/click/signUpToShopButton";
import { type ButtonProps } from "@faire/web/slate/Button";
import React from "react";

import { RSCButton } from "../RSCButton";

export const SignUpButton: React.FC<{
  type: SignUpType;
  element: SignUpElement;
  sourceId: string;
  location: { pathname: string; search: string };
  /**
   * If true, the click handler will trigger the
   * trackSignupSignUpToShopButtonClick event which
   * gets forwarded to Facebook Pixel and Google Tag Manager.
   */
  shouldSendSignUpToShopEvent?: boolean;

  variant?: ButtonProps["variant"];
  style?: ButtonProps["style"];
  dataTestId?: string;
  children: React.ReactNode;
}> = ({
  type,
  element,
  sourceId,
  location,
  shouldSendSignUpToShopEvent,
  variant,
  style,
  dataTestId,
  children,
}) => {
  const onSignUpClick = () => {
    trackSignUpClick(type, element, sourceId);
    if (shouldSendSignUpToShopEvent) {
      trackSignupSignUpToShopButtonClick();
    }
  };

  return (
    <RSCButton
      linkTo={getSignUpLink(type, location)}
      onClick={onSignUpClick}
      variant={variant}
      style={style}
      dataTestId={dataTestId}
    >
      {children}
    </RSCButton>
  );
};
